import {
    allFetch
} from "../Domain";

/**
 * @description 車部位
 */
export const CarPart = (() => {
    /**
     * @description 車部位新建
     */
    const CarPartCreate = async function (obj = {
        car_part_position: '',
        cps_code: '',
        cps_name: '',
        note: ''
    }) {
        return await allFetch('CarPart/CarPartCreate', obj);
    }
    /**
     * @description 車部位查詢
     */
    const CarPartSearch = async function (obj = {
        car_part_position: '',
        cps_code: '',
        cps_name: '',
        visible: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('CarPart/CarPartSearch', obj);
    }
    /**
     * @description 車部位查詢
     */
    const CarPartDetail = async function (obj = {
        cps_id: '',
    }) {
        return await allFetch('CarPart/CarPartDetail', obj);
    }
    /**
     * @description 車部位刪除
     */
    const CarPartDelete = async function (obj = {
        cps_id: '',
    }) {
        return await allFetch('CarPart/CarPartDelete', obj);
    }
    /**
     * @description 車部位修改
     */
    const CarPartUpdate = async function (obj = {
        cps_id: '',
        car_part_position: '',
        cps_code: '',
        cps_name: '',
        note: '',
        visible: ''
    }) {
        return await allFetch('CarPart/CarPartUpdate', obj);
    }
    return {
        CarPartCreate,
        CarPartSearch,
        CarPartDetail,
        CarPartDelete,
        CarPartUpdate
    }
})();